import { parse } from 'query-string'
import React from 'react'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import { toast } from '@/notifications'
import NotificationMessage from '@/notifications/components/NotificationMessage'
import { api } from '@/services'

import { JOB } from '../../search/constants'

import { unsubscribe, unsubscribeSuccess } from './actions'
import { getUserUnsubscriptionData } from './selectors'

const GENERIC_ERROR_MESSAGE = 'Es ist ein unbekannter Fehler aufgetreten.'

export function * removeSubscription () {
  const SUCCESS_TITLE = 'Geschafft'
  const SUCCESS_TEXT = 'Ihre persönliche Jobmail wurde erfolgreich abbestellt'
  const message = { title: SUCCESS_TITLE, text: SUCCESS_TEXT }
  const { username, code, companyJobmailId, type } = yield select(getUserUnsubscriptionData)
  const { jpmHash } = parse(document.location.search)
  let apiResponse
  try {
    if (jpmHash) {
      apiResponse = yield call(api.unsubscribeJpm, { jpmHash })
    } else if (type === JOB) {
      apiResponse = yield call(api.unsubscribeJobmail, { username, code })
    } else {
      apiResponse = yield call(api.unsubscribeCompanyJobmail, companyJobmailId, { token: code })
    }
    const { data: { success, errorMessage } } = apiResponse
    if (success) {
      toast.success(<NotificationMessage message={message} />)
      yield put(unsubscribeSuccess())
    } else {
      toast.error(errorMessage || GENERIC_ERROR_MESSAGE)
    }
  } catch (e) {
    const { data: { errorMessage } } = e.response
    toast.error(errorMessage || GENERIC_ERROR_MESSAGE)
  }
}

export default takeEvery(unsubscribe, removeSubscription)
